import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import { getEffectivePermissions } from '../utils/permissions';
import {
  isSettingsLookupOnlyNav,
  getFirstSettingsRouteSegment,
  isLookupOnlyAllowedTableSegment,
} from '../utils/settingsLookupNavAccess';

/**
 * Protected route component that checks for settings.view permission (effective = simulated when "View as" is on).
 * For roles-permissions route, also checks for settings.manage_roles.
 * Lookup editors (manage_lookups without staff/roles admin) may only open allowed lookup table routes.
 */
function ProtectedAdminRoute({ children }) {
  const location = useLocation();
  const { tenantCode } = useParams();
  const homePath = tenantCode ? `/${tenantCode}/dashboard` : '/';

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const permissions = getEffectivePermissions();
  const hasAccess = permissions.includes('settings.view');

  if (!hasAccess) {
    return <Navigate to={homePath} replace />;
  }

  const settingsSegment = getFirstSettingsRouteSegment(location.pathname);
  if (settingsSegment !== null && isSettingsLookupOnlyNav(permissions)) {
    if (!isLookupOnlyAllowedTableSegment(settingsSegment)) {
      return <Navigate to={homePath} replace />;
    }
  }

  if (location.pathname.includes('/settings/roles-permissions')) {
    const hasManageRoles = permissions.includes('settings.manage_roles');
    if (!hasManageRoles) {
      return <Navigate to={homePath} replace />;
    }
  }

  if (location.pathname.includes('/settings/document-templates')) {
    const hasManageTemplates = permissions.includes('templates.manage');
    if (!hasManageTemplates) {
      return <Navigate to={homePath} replace />;
    }
  }

  return children;
}

export default ProtectedAdminRoute;
